import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const problems = ['Tutoriales incompletos.', 'Recetas copiadas y mal explicadas.', 'Gurús que venden cursos caros llenos de teoría… pero cero práctica real.', 'Medidas "aproximadas" que arruinan lotes enteros.', 'Información fragmentada que no conecta nada.'];
export function Problem() {
  return <section className="w-full bg-[var(--bg-darker)] py-20 px-4" data-id="element-125">
      <div className="max-w-4xl mx-auto" data-id="element-126">
        <motion.h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[var(--accent-orange)] mb-8 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-127">
          La Verdad Brutal Que Nadie Te Dice
        </motion.h2>

        <motion.p className="text-xl md:text-2xl text-[var(--text-light)] mb-6 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-128">
          El problema no es que "no sirvas para esto".
        </motion.p>

        <motion.p className="text-xl md:text-2xl text-[var(--text-light)] mb-12 text-center font-bold" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} data-id="element-129">
          El problema es que el mercado está lleno de:
        </motion.p>

        <div className="space-y-4 mb-12" data-id="element-130">
          {problems.map((problem, index) => <motion.div key={index} className="flex items-start gap-4 bg-[var(--bg-card)] p-6 rounded-lg" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} data-id="element-131">
              <XCircleIcon className="w-6 h-6 md:w-8 md:h-8 text-red-500 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-132" />
              <p className="text-lg md:text-xl text-[var(--text-light)]" data-id="element-133">
                {problem}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-134">
          <p className="text-2xl md:text-3xl font-bold text-[var(--accent-orange)] mb-4" data-id="element-135">
            Es basura disfrazada de contenido.
          </p>
          <p className="text-xl md:text-2xl text-[var(--text-gray)]" data-id="element-136">
            Y eso es lo que hace que la mayoría abandone antes siquiera de
            vender su primer jabón.
          </p>
        </motion.div>
      </div>
    </section>;
}